import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tooltip,
  Chip,
  Badge,
  Box,
  Menu,
  Divider,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  Popover,
  Button,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  TablePagination,
  Tab,
} from "@mui/material";
import CustomTooltip from "../../../../src/utils/CustomTooltip";
import {
  Download,
  Done,
  Close,
  PauseCircle,
  Edit,
  Cancel,
  MoreVert,
} from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { display, Stack, textAlign, width } from "@mui/system";
import moment from "moment/moment";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import AsyncDropdown from "../../../utils/asyncDropdown/AsyncDropdown";
import { getActivepanels } from "../../managePanel/managePanel.api";
import {
  getAllLanguage,
  getActiveCountry,
  getSurveyParticipationPointsDetail,
  getSurveyParticipationPoints,
  getPanelistPointDetail,
  getPanelistPointSummary,
  getPanelistPointRedeemedDetail,
  getPanelistPointRedeemed,
  getPanelistDetails,
  getLoginHistory,
  updateW9Status,
} from "../panelistDetail.api";
import CustomDataTable from "../../../views/CustomTable/CustomDataTable";
import { LoadingButton } from "@mui/lab";
import ConfirmAlert from "../../../utils/ConfirmAlert";
import { SnackBarAlert } from "../../../utils/SnackBar";
import "../../panelistDetail/PanelList.css";
import {
  updatePanelist,
  getPanelistById,
  getPanelistCategory,
  getAnsweredQuestionPercentage,
  getPanelistActivity
} from "../panelistDetail.api";
import { useParams } from "react-router-dom";
import validationPatterns from "../../../utils/ZipValidationPatterns.json";
import { copyToClipboard } from "../../../utils/copyToClipboard/copyToClipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SearchIcon from "@mui/icons-material/Search";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Avatar from "@mui/material/Avatar";
import * as Flags from 'country-flag-icons/react/3x2';

// MUI Icons
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";
import LoginIcon from "@mui/icons-material/Login";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LaptopIcon from "@mui/icons-material/Laptop";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
// import EditIcon from "@mui/icons-material/Edit";

const dropDowns = {
  LANGUAGE: "LANGUAGE",
  COUNTRY: "COUNTRY",
  USERTYPE: "USERTYPE",
  USERSTATUS: "USERSTATUS",
  CLIENT: "CLIENT",
  POINTTYPE: "POINTTYPE",
};
const PanelistForm = (props) => {
  const { editData } = props;
  const adminId = useSelector((state) => state.auth.userData?.tenantId);
  const data = {
    panelGuid: "75a22a9e-d0e4-4547-af6b-6156bb0760eb",
    panelId: 30,
  };
  const [activePanels, setActivePanels] = useState([]);
  const [countries, setCountries] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({});
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [columns, setColumns] = useState([]);
  const [surveyColumns, setSurveyColumns] = useState([]);
  const [redeemColumns, setRedeemColumns] = useState([]);
  const [pending, setPending] = useState(true);
  const [reconcileRate, setReconcileRate] = useState(0.0);
  const [reconcile, setReconcile] = useState(0);
  const [conversion, setConversion] = useState(0.0);
  const [revenue, setRevenue] = useState(0);
  const [totalcost, setTotalcost] = useState(0.0);
  const [panelistData, setPanelistData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dob: moment().format("YYYY-MM-DD"),
    age: 0,
    email: "",
    zipCode: "",
    mobile: "",
    countryId: 0,
    languageId: 0,
    currency: "",
    address: "",
    state: "",
    city: "",
    joinIp: "",
    joinDate: moment().format("YYYY-MM-DD"),
    createdAt: moment().format("YYYY-MM-DD"),
    updatedAt: moment().format("YYYY-MM-DD"),
    isEmailVerified: false,
    emailVerifyDate: moment().format("YYYY-MM-DD"),
    device: "",
    sourceName: "",
    unsubscribe: false,
    unsubscribeDate: moment().format("YYYY-MM-DD"),
    isSampleAllow: false,
    isActive: false,
    usertype: 0,
    levelId: 0,
    reconcile: 0,
    rrate: 0.0,
    conversion: 0.0,
    revenue: 0,
    totalcost: 0.0,
    emailScore: 0,
    ipFraudScore: 0,
    visitorID: "",
    prevEmail: "",
    deleteReason: "",
    categoryType: "",
    paypalEmail: "",
    description:"",
    promoCode: ""
  });
  const [editingRowId, setEditingRowId] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const [questionPercentage, setQuestionPercentage] = useState({});
  const [categoryItem, setCategoryItem] = useState(null);
  const [levelList, setLevelList] = useState([
    {
      id: 1,
      levelName: "Level 1",
    },
    {
      id: 2,
      levelName: "Level 2",
    },
    {
      id: 3,
      levelName: "Level 3",
    },
    {
      id: 4,
      levelName: "Level 4",
    },
  ]);
  const [levelItem, setLevelItem] = useState(null);

  const [panelistId, setPanelistId] = useState("");
  const [Points, setPoints] = useState({
    totalPoints: 0,
    totalSurveyPoint: 0,
    totalRefferalPoint: 0,
    totalMiniSurveyPoint: 0,
    totalTerminateCost: 0.0,
    totalReconcilePoints: 0.0,
    totalTerminatePoint: 0,
  });
  const [selectedClient, setSelectedClient] = useState({ clientName: "All" });
  const [appliedSurveyCode, setAppliedSurveyCode] = useState("");
  const [SurveyPointsDetail, setSurveyPointsDetail] = useState([]);
  const [selectedUserStatus, setSelectedUserStatus] = useState({
    userStatus: "All",
  });
  const [filteredSurveyPointsDetail, setFilteredSurveyPointsDetail] = useState(
    [],
  );
  const [filteredPointsDetail, setFilteredPointsDetail] = useState([]);
  const [selectedPointType, setSelectedPointType] = useState({
    pointTypeName: "All",
  });
  const [pointsDetail, setPointsDetail] = useState([]);
  const [SurveyPoints, setSurveyPoints] = useState({
    totalAttempts: 0,
    completes: 0,
    terminates: 0,
    quotaFull: 0,
    inCompletes: 0,
    reconcile: 0,
  });
  const [RedemptionPointsDetail, setRedemptionPointsDetail] = useState([]);
  const [RedemptionPoints, setRedemptionPoints] = useState({
    totalPoints: 0,
    pointredeemed: 0,
    balancepoints: 0,
    approvedPoints: 0,
    rejectedPoints: 0,
    pendingPoints: 0,
  });
  const [validationError, setvalidationError] = useState({
    email: "",
    zipCode: "",
  });
  const [alert, setAlert] = useState(false);
  const [isDisableUpdate, setIsDisableUpdate] = useState(false);
  const { id } = useParams();
  const [zipMaxLength, setZipMaxLength] = useState(30);
  const [userTypes, setUserTypes] = useState([
    { id: 0, userType: "0" },
    { id: 1, userType: "1" },
    { id: 2, userType: "2" },
    { id: 3, userType: "3" },
    { id: 4, userType: "4" },
    { id: 5, userType: "5" }
  ]);
  const [selectedUserType, setSelectedUserType] = useState({ id: 0, userType: 0 });
  const [w9FormColumns, setW9FormColumns] = useState([]);
  const [W9FormDetail, setW9FormDetail] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pendingW9Action, setPendingW9Action] = useState(false);

  const w9FormRemoveObj = ["fw9Url"];
  const [redemptionPointDivider, setRedemptionPointDivider] = useState(100);
  const [profit, setProfit] = useState("0");
  const W9_STATUS_MAP = {
    1: { label: "Verified", color: "success" },
    2: { label: "Invalid", color: "error" },
    3: { label: "Pending", color: "warning" },
  };
  const [surveyCodeSearch, setSurveyCodeSearch] = useState("");
  const [surveyCodeAnchorEl, setSurveyCodeAnchorEl] = useState(null);
  const [openActivityLog, setOpenActivityLog] = useState(false);
  const [openLoginHistory, setOpenLoginHistory] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [loginHistoryData, setLoginHistoryData] = useState([]);
  const [activityLogMessage, setActivityLogMessage] = useState("");
  const [activityLogs, setActivityLogs] = useState([]);
  const [historyTab, setHistoryTab] = useState(0); // 0 = Login History, 1 = Varisoul Status History
  const [varisoulHistory, setVarisoulHistory] = useState([]); // [{ varisoulScore, vpn, proxy, trueCountry, createdAt }]
  const [varisoulMessage, setVarisoulMessage] = useState(
    "No Verisoul status history found",
  );
  const [loginPage, setLoginPage] = useState(0);
  const [loginRowsPerPage, setLoginRowsPerPage] = useState(10);
  const [activityPage, setActivityPage] = useState(0);
  const [activityRowsPerPage, setActivityRowsPerPage] = useState(10);
  // ─── Avatar background colors per action type ─────────────────
  const avatarBg = {
    subscribe: "#E1F5EE",
    unsubscribe: "#FCEBEB",
    "notif-on": "#FAEEDA",
    "notif-off": "#FCEBEB",
    profile: "#EEEDFE",
  };

  // ─── Avatar icon colors per action type ───────────────────────
  const avatarColor = {
    subscribe: "#0F6E56",
    unsubscribe: "#A32D2D",
    "notif-on": "#854F0B",
    "notif-off": "#A32D2D",
    profile: "#534AB7",
  };

  // ─── Avatar icons per action type ─────────────────────────────
  // const avatarIcon = {
  //   subscribe: <PersonAddIcon sx={{ fontSize: 16 }} />,
  //   unsubscribe: <AdminPanelSettingsIcon sx={{ fontSize: 16 }} />,
  //   "notif-on": <NotificationsIcon sx={{ fontSize: 16 }} />,
  //   "notif-off": <NotificationsOffIcon sx={{ fontSize: 16 }} />,
  //   profile: <EditIcon sx={{ fontSize: 16 }} />,
  // };
  useEffect(() => {
    if (adminId) {
      getActivepanels(adminId)
        .then((res) => {
          if (res?.status === 200) {
            const { data } = res.data;
            setActivePanels(data);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }, [adminId]);

  useEffect(() => {
    if (!adminId || !editData?.panelistId) return;
    let zipPatternObjects = validationPatterns.filter((e) =>
      e.countryids.find((l) => l == editData.countryId),
    );
    setZipMaxLength(zipPatternObjects[0].maxlength);

    getAllLanguage()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          // console.log("... language data", data);

          setLanguages(data);
        }
      })
      .catch((err) => console.log(err));

    getActiveCountry()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          // console.log("... country data", data);
          setCountries(data);
          //setSelectedCountry(data[0]);
        }
      })
      .catch((err) => console.log(err));

    getPanelistPointSummary(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... points data", data);
            data[0].totalTerminateCost =
              data[0].totalTerminateCost != null
                ? parseFloat(data[0].totalTerminateCost).toFixed(2)
                : 0.0;
            data[0].totalReconcilePoints =
              data[0].totalReconcilePoints != null
                ? parseFloat(data[0].totalReconcilePoints).toFixed(2)
                : 0.0;

            setPoints(data[0]);
          } else {
            setPoints({
              totalPoints: 0,
              totalSurveyPoint: 0,
              totalRefferalPoint: 0,
              totalMiniSurveyPoint: 0,
              totalTerminateCost: 0.0,
              totalReconcilePoints: 0.0,
              totalTerminatePoint: 0,
            });
          }
        }
      })
      .catch((err) => console.log(err));

    getPanelistPointDetail(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... points details data", data);
            setPointsDetail(data);
          }
        }
      })
      .catch((err) => console.log(err));

    getSurveyParticipationPoints(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... Surveypoints data", data);
            setSurveyPoints(data[0]);
            setReconcileRate(data[0].rrate);
            setReconcile(data[0].reconcile);
            setConversion(data[0].conversion);
            setRevenue(data[0].revenue);
            setTotalcost(
              data[0].totalcost != null
                ? parseFloat(data[0].totalcost).toFixed(2)
                : 0.0,
            );

            setProfit(
              data[0].profit != null
                ? parseFloat(data[0].profit).toFixed(2).toString()
                : "0",
            );
          } else {
            // console.log("... Surveypoints data", data);
            setSurveyPoints({
              totalAttempts: 0,
              completes: 0,
              terminates: 0,
              quotaFull: 0,
              inCompletes: 0,
              reconcile: 0,
            });

            setReconcileRate(0.0);
            setReconcile(0);
            setConversion(0.0);
            setRevenue(0);
            setTotalcost(0.0);
          }
        }
      })
      .catch((err) => console.log(err));

    getSurveyParticipationPointsDetail(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... points details data", data);
            setSurveyPointsDetail(data);
          }
        }
      })
      .catch((err) => console.log(err));

    getPanelistPointRedeemed(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... Redeem data", data);
            setRedemptionPoints(data[0]);
          } else {
            setRedemptionPoints({
              totalPoints: 0,
              pointredeemed: 0,
              balancepoints: 0,
              approvedPoints: 0,
              rejectedPoints: 0,
              pendingPoints: 0,
            });
          }
        }
      })
      .catch((err) => console.log(err));

    getPanelistPointRedeemedDetail(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            // console.log("... Redeem points details data", data);
            setRedemptionPointsDetail(data);
          }
        }
      })
      .catch((err) => console.log(err));

      getLoginHistory(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { success } = res.data;
          const { loginHistory, verisoulStatus } = res?.data?.data[0];
          if (success) {
            setLoginHistoryData(loginHistory || []);
            setVarisoulHistory(verisoulStatus || []);
            if(loginHistory.length == 0){
              setLoginMessage("No login history available.");
            } else {
              setLoginMessage("");
            }
          } else {
            setLoginMessage("No login history available.");
            setLoginHistoryData([]);
          }
        } else {
          setLoginMessage("Something went wrong. Please contact the dev team.");
          setLoginHistoryData([]);
        }
      })
      .catch((err) => {
        setLoginMessage("Something went wrong. Please contact the dev team.");
        setLoginHistoryData([]);
      });
      
      getPanelistActivity(editData?.panelistId)
      .then((res) => {
        if (res?.status === 200) {
          const { data, success } = res.data;
          if (success) {
            setActivityLogs(data || []);
            setActivityLogMessage("")            
          } else {
            setActivityLogMessage("No activity history available.")
            setActivityLogs([]);
          }
        } else {
          setActivityLogMessage("Something went wrong. Please contact the dev team.")
          setActivityLogs([]);
        }
      });

      getAnsweredQuestionPercentage(editData?.panelistId)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const uniqueItems = res.data.data[0];
          setQuestionPercentage(uniqueItems);
        } else {
          setQuestionPercentage({});
        }
      })
      .catch(() => setQuestionPercentage({}));
  }, [adminId, editData?.panelistId]);

  useEffect(() => {
    if (editData?.panelistId) {
      // console.log("edit data", editData);
      setPanelistId(editData.panelistId);
      let duplicate = { ...panelistData };
      duplicate.firstName = editData?.firstName;
      duplicate.lastName = editData?.lastName;
      duplicate.gender = editData?.gender;
      duplicate.dob = moment(editData?.dob).format("YYYY-MM-DD");
      duplicate.age = editData?.age;
      duplicate.email = editData?.email;
      duplicate.zipCode = editData?.zipCode;
      duplicate.createdAt = editData?.createdAt;
      duplicate.updatedAt = editData?.updatedAt;
      duplicate.languageId = editData?.languageId;
      duplicate.countryId = editData?.countryId;
      duplicate.currency = editData?.currency;
      duplicate.address = editData?.address;
      duplicate.state = editData?.state;
      duplicate.city = editData?.city;
      duplicate.mobile = editData?.mobile;
      duplicate.joinIp = editData?.joinIp;
      duplicate.joinDate = moment(editData?.joinDate).format("YYYY-MM-DD");
      duplicate.isEmailVerified = editData?.isEmailVerified;
      duplicate.emailVerifyDate = editData?.emailVerifyDate
        ? moment(editData?.emailVerifyDate).format("YYYY-MM-DD")
        : "";
      duplicate.device =
        editData.device === 1
          ? "iOS"
          : editData?.device === 2
            ? "Android"
            : "Website";
      duplicate.sourceName = editData?.sourceName;
      duplicate.unsubscribe = editData?.unsubscribe; //add
      duplicate.unsubscribeDate = editData?.unsubscribeDate
        ? moment(editData?.unsubscribeDate).format("YYYY-MM-DD")
        : "";
      duplicate.isSampleAllow = editData?.isSampleAllow;
      duplicate.isActive = editData?.isActive;
      duplicate.usertype = editData?.usertype;
      duplicate.levelId = editData?.levelId;
      duplicate.reconcile = editData?.reconcile;
      duplicate.rrate = editData?.rrate;
      duplicate.conversion = editData?.conversion;
      duplicate.revenue = editData?.revenue;
      duplicate.totalcost = editData?.totalcost?.toFixed(2);
      duplicate.emailScore = editData?.emailScore;
      duplicate.ipFraudScore = editData?.ipFraudScore;
      duplicate.visitorID = editData?.visitorid;
      duplicate.prevEmail = editData?.prevEmail;
      duplicate.deleteReason = editData?.deleteReason;
      duplicate.categoryType = editData?.category;
      duplicate.paypalEmail = editData?.paypalEmail;
      duplicate.promoCode = editData?.promoCode;
      duplicate.description = editData?.description;
      // setPanelistData(duplicate);
      if (languages?.length > 0) {
        const item = languages.find((i) => i.id === editData.languageId);
        if (item) {
          setSelectedLanguage(item);
        }
      }

      if (countries?.length > 0) {
        const item = countries.find((i) => i.countryId === editData.countryId);
        if (item) {
          setSelectedCountry(item);
        }
      }

      if (userTypes.length > 0) {
        const item = userTypes.find((i) => i.userType == editData.usertype);
        if (item) {
          setSelectedUserType(item);
        }
      }

      setPanelistData(duplicate);
    }

    return () => {
      setPanelistData({
        firstName: "",
        lastName: "",
        gender: "",
        dob: moment().format("YYYY-MM-DD"),
        age: 0,
        email: "",
        zipCode: "",
        mobile: "",
        countryId: 0,
        languageId: 0,
        currency: "",
        address: "",
        state: "",
        city: "",
        joinIp: "",
        joinDate: moment().format("YYYY-MM-DD"),
        createdAt: moment().format("YYYY-MM-DD"),
        updatedAt: moment().format("YYYY-MM-DD"),
        isEmailVerified: false,
        emailVerifyDate: moment().format("YYYY-MM-DD"),
        device: "",
        sourceName: "",
        unsubscribe: false,
        unsubscribeDate: moment().format("YYYY-MM-DD"),
        isSampleAllow: false,
        isActive: false,
        usertype: 0,
        levelId: 0,
        reconcile: 0,
        rrate: 0.0,
        conversion: 0.0,
        revenue: 0,
        totalcost: 0.0,
        emailScore: 0,
        ipFraudScore: 0,
        visitorID: "",
        prevEmail: "",
        deleteReason: "",
        promoCode: "",
        description:"",
        categoryType: "",
        paypalEmail: "",
      });
    };
  }, [editData, activePanels, languages, countries]);

  useEffect(() => {
    let filtered = SurveyPointsDetail;

    if (selectedUserStatus.userStatus !== "All") {
      filtered = filtered.filter(
        (item) => item.userStatus === selectedUserStatus.userStatus,
      );
    }

    if (selectedClient.clientName !== "All") {
      filtered = filtered.filter(
        (item) => item.clientName === selectedClient.clientName,
      );
    }

    if (appliedSurveyCode) {
      filtered = filtered.filter((item) =>
        item.surveycode?.toLowerCase().includes(appliedSurveyCode.toLowerCase()),
      );
    }

    setFilteredSurveyPointsDetail(filtered);
  }, [
    SurveyPointsDetail,
    selectedUserStatus,
    selectedClient,
    appliedSurveyCode,
  ]);

  useEffect(() => {
    let filtered = pointsDetail;
    if (selectedPointType.pointTypeName !== "All") {
      filtered = filtered.filter(
        (item) => item.pointType === selectedPointType.pointTypeName,
      );
    }
    setFilteredPointsDetail(filtered);
  }, [pointsDetail, selectedPointType]);

  const handleDropDownChange = (value, dropDownName) => {
    switch (dropDownName) {
      case dropDowns.LANGUAGE:
        setSelectedLanguage(value);
        handleAssignId("Language", value.id);
        break;
      case dropDowns.COUNTRY:
        setSelectedCountry(value);
        handleAssignId("Country", value.id);
        break;

      case dropDowns.USERTYPE:
        setSelectedUserType(value);
        handleAssignId("UserType", value.id);
        break;
      case dropDowns.USERSTATUS:
        setSelectedUserStatus(value);
        break;
      case dropDowns.CLIENT:
        setSelectedClient(value);
        break;
      case dropDowns.POINTTYPE:
        setSelectedPointType(value);
        break;
      default:
        break;
    }
  };

  const handleAssignId = (keyName, id) => {
    if (keyName && id) {
      setPanelistData((prev) => ({
        ...prev,
        [keyName]: id,
      }));
    }
  };

  const handleLoginHistory = () => {
    setHistoryTab(0);
    setLoginPage(0);
    setOpenLoginHistory(true);
  };

  const handleActivityHistory = () => {
    setActivityPage(0);
    setOpenActivityLog(true);
  };

  const handleLoginPageChange = (event, newPage) => {
    setLoginPage(newPage);
  };

  const handleLoginRowsPerPageChange = (event) => {
    setLoginRowsPerPage(parseInt(event.target.value, 10));
    setLoginPage(0);
  };

  const handleActivityPageChange = (event, newPage) => {
    setActivityPage(newPage);
  };

  const handleActivityRowsPerPageChange = (event) => {
    setActivityRowsPerPage(parseInt(event.target.value, 10));
    setActivityPage(0);
  };

  const paginatedLoginHistory = useMemo(() => {
    const start = loginPage * loginRowsPerPage;
    return loginHistoryData.slice(start, start + loginRowsPerPage);
  }, [loginHistoryData, loginPage, loginRowsPerPage]);

  const paginatedActivityHistory = useMemo(() => {
    const start = activityPage * activityRowsPerPage;
    return activityLogs.slice(start, start + activityRowsPerPage);
  }, [activityLogs, activityPage, activityRowsPerPage]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSurveyColumns([
        {
          name: (
            <Tooltip title="Survey ID" placement="top">
              <span>Id</span>
            </Tooltip>
          ),
          selector: (row) => row.surveyid,
          sortable: true,
          width: "100px",
        },
        {
          name: (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
                fontWeight: 600,
              }}
              onClick={(e) => {
                e.stopPropagation();
                setSurveyCodeAnchorEl(e.currentTarget);
              }}
            >
              <span>Code</span>
              <SearchIcon sx={{ fontSize: "14px" }} />
            </Box>
          ),
          selector: (row) => (
            <CustomTooltip
              title={row.surveycode || "N/A"}
              childrenText={row.surveycode || "--"}
              copiedText
            />
          ),
          sortable: true,
          width: "100px",
        },
        {
          name: (
            <Tooltip title="Participation Category" placement="top">
              <span>Category </span>
            </Tooltip>
          ),
          selector: (row) => (
            <CustomTooltip
              title={row.category || "N/A"}
              childrenText={row.category || "--"}
            />
          ),
          sortable: true,
          width: "100px",
        },
        {
          name: (
            <span>CCPI</span>
          ),
          selector: (row) => (row.ccpi || "--" ),
          sortable: true,
          width: "80px",
        },
        {
          name: (
            <span>CPI</span>
          ),
          selector: (row) => (row.completedPoints/100 || "--" ),
          sortable: true,
          width: "80px",
        },
        {
          name: (
            <Tooltip title="Filter all Clients" placement="top">
              <FormControl
                size="small"
                variant="standard"
                sx={{ minWidth: 100 }}
              >
                <Select
                  value={selectedClient.clientName}
                  onChange={(e) => {
                    handleDropDownChange(
                      { clientName: e.target.value },
                      dropDowns.CLIENT,
                    );
                  }}
                  displayEmpty
                  disableUnderline
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#fff",
                    height: "100%",
                    ".MuiSelect-select": {
                      padding: 0,
                      paddingRight: "12px !important",
                      textAlign: "left",
                    },
                    ".MuiSelect-icon": {
                      color: "#fff",
                    },
                  }}
                >
                  <MenuItem value="All">Clients</MenuItem>
                  {SurveyPointsDetail && SurveyPointsDetail.length > 0
                    ? [
                        ...new Set(
                          SurveyPointsDetail.map(
                            (item) => item.clientName,
                          ).filter(
                            (client) =>
                              client != null &&
                              client !== "" &&
                              client !== undefined,
                          ),
                        ),
                      ].map((client, index) => (
                        <MenuItem key={index} value={client}>
                          {client}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Tooltip>
          ),
          selector: (row) => row.clientName || "--",
          width: "100px",
          cell: (row) => (
            <CustomTooltip
              title={row.clientName || "N/A"}
              childrenText={row.clientName || "--"}
            />
          ),
        },
        {
          name: (
            <Tooltip title="Filter User Status" placement="top">
              <FormControl
                size="small"
                variant="standard"
                sx={{ minWidth: 120 }}
              >
                <Select
                  value={selectedUserStatus.userStatus}
                  onChange={(e) => {
                    handleDropDownChange(
                      { userStatus: e.target.value },
                      dropDowns.USERSTATUS,
                    );
                  }}
                  displayEmpty
                  disableUnderline
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#fff",
                    height: "100%",
                    ".MuiSelect-select": {
                      padding: 0,
                      paddingRight: "12px !important",
                      textAlign: "left",
                    },
                    ".MuiSelect-icon": {
                      color: "#fff",
                    },
                  }}
                >
                  <MenuItem value="All">User Status</MenuItem>
                  {SurveyPointsDetail && SurveyPointsDetail.length > 0
                    ? [
                        ...new Set(
                          SurveyPointsDetail.map(
                            (item) => item.userStatus,
                          ).filter(
                            (status) =>
                              status != null &&
                              status !== "" &&
                              status !== undefined,
                          ),
                        ),
                      ].map((status, index) => (
                        <MenuItem key={index} value={status}>
                          {status}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Tooltip>
          ),
          selector: (row) => row.userStatus,
          width: "110px",
          cell: (row) => (
            <CustomTooltip
              title={row.userStatus || "N/A"}
              childrenText={row.userStatus || "--"}
            />
          ),
        },
        {
          name: (
            <Tooltip title="Completed Points" placement="top">
              <span>Points </span>
            </Tooltip>
          ),
          selector: (row) => row.points || 0,
          sortable: true,
          width: "100px",
          cell: (row) => row.points || "--",
        },
        {
          name: (
            <Tooltip title="Survey Attempted From" placement="top">
              <span>From </span>
            </Tooltip>
          ),
          selector: (row) => row.surveyFrom || "--",
          sortable: true,
          width: "100px",
        },
        {
          name: (
            <Tooltip title="Reconcile" placement="top">
              <span>Reconcile</span>
            </Tooltip>
          ),
          selector: (row) => row.isReconcile,
          sortable: true,
          cell: (row) => (row.isReconcile == true ? <>{"True"}</> : "False"),
          width: "100px",
        },
        {
          name: (
            <Tooltip title="Original Status" placement="top">
              <span>Status</span>
            </Tooltip>
          ),
          selector: (row) => row.originalStatus,
          sortable: true,
          width: "100px",
          cell: (row) =>
            row.originalStatus != null ? row.originalStatus : "--",
        },

        {
          name: "Start Date",
          // selector: (row) => row?.startDate ? moment.utc(row?.startDate).format("YYYY-MM-DD HH:mm") : "-",
          selector: (row) =>
            row?.startDate ? (
              <CustomTooltip
                title={
                  moment(row?.startDate).format("YYYY-MM-DD HH:mm") || "N/A"
                }
                childrenText={
                  moment(row?.startDate).format("YYYY-MM-DD HH:mm") || "--"
                }
              />
            ) : (
              "-"
            ),

          sortable: true,
           width: "140px",
        },
        {
          name: "End Date",
          // selector: (row) => row?.endDate ? moment.utc(row?.endDate).format("YYYY-MM-DD HH:mm") : "-",
          selector: (row) =>
            row?.endDate ? (
              <CustomTooltip
                title={
                  moment(row?.endDate).format("YYYY-MM-DD HH:mm") || "N/A"
                }
                childrenText={
                  moment(row?.endDate).format("YYYY-MM-DD HH:mm") || "--"
                }
              />
            ) : (
              "-"
            ),
           width: "140px",
          sortable: true,
        },
        {
          name: (
            <Tooltip title="Time Taken" placement="top">
              <span>Taken</span>
            </Tooltip>
          ),
          selector: (row) => (
            <CustomTooltip
              title={renderSurveyTimeCalculation(row?.startDate, row?.endDate) || "N/A"}
              childrenText={renderSurveyTimeCalculation(row?.startDate, row?.endDate) || "--"}
            />
          ),
          sortable: true,
          width: "100px",
        },
      ]);
      setPending(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [SurveyPointsDetail, selectedUserStatus, selectedClient, appliedSurveyCode]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setColumns([
        {
          name: "Point ID",
          selector: (row) => row.id,
          sortable: true,
        },
        {
          name: "Survey ID",
          selector: (row) => row.surveyId || "--",
          sortable: true,
        },
        {
          name: "Points",
          selector: (row) => row.points || 0,
          sortable: true,
        },
        {
          selector: (row) => (
            <CustomTooltip
              title={row?.pointType || "N/A"}
              childrenText={row?.pointType || "--"}
            />
          ),
          name: (
            <Tooltip title="Filter Points Type" placement="top">
              <FormControl
                size="small"
                variant="standard"
                sx={{ minWidth: 120 }}
              >
                <Select
                  value={selectedPointType.pointTypeName}
                  onChange={(e) => {
                    handleDropDownChange(
                      { pointTypeName: e.target.value },
                      dropDowns.POINTTYPE,
                    );
                  }}
                  displayEmpty
                  disableUnderline
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#fff",
                    height: "100%",
                    ".MuiSelect-select": {
                      padding: 0,
                      paddingRight: "12px !important",
                      textAlign: "left",
                    },
                    ".MuiSelect-icon": {
                      color: "#fff",
                    },
                  }}
                >
                  <MenuItem value="All">Points Type</MenuItem>
                  {pointsDetail && pointsDetail.length > 0
                    ? [
                        ...new Set(
                          pointsDetail.map((item) =>
                            item?.pointType.toString(),
                          ),
                        ),
                      ].map((status, index) => (
                        <MenuItem key={index} value={status}>
                          {status}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Tooltip>
          ),
        },
        {
          name: "User Status",
          selector: (row) => (
             <CustomTooltip
              title={row?.UserStatus || "N/A"}
              childrenText={row?.UserStatus || "--"}
            />
          ),
          sortable: true,
        },
        {
          name: "Created ON",
          selector: (row) => moment(row.createdAt).format("YYYY-MM-DD"),
          sortable: true,
        },
      ]);
      setPending(false);
    }, 3000);
    return () => clearTimeout(timeout);
  }, [pointsDetail, selectedPointType.pointTypeName]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setRedeemColumns([
        {
          name: "ID",
          selector: (row) => row.id,
          sortable: true,
          width: "8%",
        },
        {
          name: "Points",
          selector: (row) => row.pointsRedeemed,
          sortable: true,
          width: "10%",
        },
        {
          name: "USD",
          selector: (row) => row.USDAmount,
          sortable: true,
          width: "7%",
        },
        {
          name: (
            <Tooltip title="Local Currency" placement="top">
              <div>Currency</div>
            </Tooltip>
          ),
          selector: (row) => row.currencyAmount,
          sortable: true,
          width: "8%",
        },
        {
          name: "Reward",
          selector: (row) => (
            <CustomTooltip
              title={row?.rewardName || "N/A"}
              childrenText={row?.rewardName || "--"}
            />
          ),
          sortable: true,
          width: "15%",
        },
        {
          name: "Status",
          selector: (row) => row.status || "--",
          sortable: true,
          width: "12%",
        },
        {
          name: (
            <Tooltip title="VisitorID Count" placement="top">
              <div className="conversion-header">VID</div>
            </Tooltip>
          ),
          selector: (row) => (
            <CustomTooltip
              title={row?.vPanelistId?.join(", ") || "N/A"}
              childrenText={row.visitorCount}
              copiedText
            />
          ),
          sortable: true,
          width: "6%",
        },
        {
          name: "Reason",
          selector: (row) => (
            <CustomTooltip
              title={row.disapprovedReason || "No reason provided"}
              childrenText={row.disapprovedReason || "N/A"}
            />
          ),
          sortable: true,
          width: "13%",
        },
        {
          name: "Created",
          selector: (row) => moment(row.createdAt).format("YY-MM-DD"),
          sortable: true,
          width: "10%",
        },
        {
          name: <div>Updated</div>,
          selector: (row) => moment(row.updatedAt).format("YY-MM-DD"),
          sortable: true,
          width: "10%",
        },
      ]);

      setPending(false);
    }, 0);
    return () => clearTimeout(timeout);
  }, [panelistData]);

  useEffect(() => {
    getPanelistCategory()
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const uniqueItems = res.data.data;
          setCategoryList(uniqueItems);
        } else {
          setCategoryList([]);
        }
      })
      .catch(() => setCategoryList([]));
  }, []);

  useEffect(() => {
    if (categoryList.length && panelistData?.categoryType) {
      const defaultCategory = categoryList.find(
        (item) => item.categoryType === panelistData.categoryType,
      );
      if (defaultCategory) setCategoryItem(defaultCategory);

      const defaultLevel = levelList.find(
        (item) => item.id === panelistData.levelId,
      );
      if (defaultLevel) setLevelItem(defaultLevel);
    }
  }, [editData, categoryList, levelList]);

  const handleCategoryChange = (value) => {
    setCategoryItem(value);
  };

  function Flag({ code, size = 24 }) {
    const FlagComponent = Flags[code.toUpperCase()];
    if (!FlagComponent) return null;
    return <FlagComponent title={code} style={{ width: size }} />;
  }

  const handleW9Form = (value, action) => {
    const w9StatusBody = {
      panelistId: value?.panelistId,
      status: action,
    };
    updateW9Status(w9StatusBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setEditingRowId(true);
          setAlert("W-9 form status updated successfully.");
          fetchPanelistDetails();
        } else {
          setAlert("Failed to update W-9 form status.");
        }
      })
      .catch((err) => {
        setAlert("Failed to update W-9 form status.");
      });
  };

  useEffect(() => {
    fetchPanelistDetails();
  }, [editData?.panelistId]);

  const fetchPanelistDetails = () => {
    if (!editData?.panelistId) return;
    setPendingW9Action(true);
    getPanelistDetails(editData.panelistId)
      .then((res) => {
        if (res?.status === 200 && res.data?.success) {
          setW9FormDetail(res.data.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setPendingW9Action(false));
  };

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleLevelChange = (value) => {
    setLevelItem(value);
  };

  useEffect(() => {
    setW9FormColumns([
      {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        grow: 1,
        cell: (row) => {
          const statusInfo = W9_STATUS_MAP[row.status || 3];
          return statusInfo ? (
            <Chip
              label={statusInfo.label}
              color={statusInfo.color}
              size="small"
              sx={{
                fontWeight: 500,
                minWidth: "60px",
              }}
            />
          ) : null;
        },
      },

      {
        name: "Panelist Id",
        selector: (row) => row.panelistId,
        sortable: true,
        grow: 1,
      },
      {
        name: "First Name",
        selector: (row) => row.firstName,
        cell: (row) => (
            <CustomTooltip title={row.firstName || "--"} childrenText={row.firstName} />
        ),
        sortable: true,
        grow: 1,
      },
      {
        name: "Last Name",
        selector: (row) => row.lastName,
        cell: (row) => (
          <CustomTooltip
            title={row.lastName || "--"}
            childrenText={row.lastName}
          />
        ),
        sortable: true,
        grow: 1,
      },
      {
        name: "SSN",
        selector: (row) => (row.ssn == null ? "--" : row.ssn),
        cell: (row) => (
          <CustomTooltip title={row.ssn || "--"} childrenText={row.ssn} />
        ),
        sortable: true,
        width: "100px",
      },
      {
        name: "Address",
        selector: (row) => (row.address == null ? "--" : row.address),
        sortable: true,
        cell: (row) => (
          <CustomTooltip
            title={row.address || "--"}
            childrenText={row.address}
          />
        ),
        width: "90px",
      },

      {
        name: "City",
        selector: (row) => (row.city == null ? "--" : row.city),
        sortable: true,
        cell: (row) => (
          <CustomTooltip title={row.city || "--"} childrenText={row.city} />
        ),
        width: "90px",
      },
      {
        name: "State",
        selector: (row) => (row.state == null ? "--" : row.state),
        sortable: true,
        grow: 1,
      },
      {
        name: "Updated At",
        selector: (row) => moment(row.updatedAt).format("YYYY-MM-DD"),
        cell: (row) => (
          <CustomTooltip
            title={moment(row.updatedAt).format("YYYY-MM-DD") || "--"}
            childrenText={row.updatedAt}
          />
        ),
        sortable: true,
        grow: 1,
      },
      {
        name: "Actions",
        grow: 1,
        cell: (row) => (
          <Stack direction={"row"}>
            <Tooltip title="Actions">
              <IconButton size="small" onClick={(e) => handleMenuOpen(e, row)}>
                <MoreVert fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download W-9">
              <IconButton
                size="small"
                onClick={() =>
                  handleDownloadW9(
                    W9FormDetail[0]?.fw9Url,
                    `W9-${W9FormDetail[0]?.firstName}.pdf`,
                  )
                }
              >
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        ),
      },
    ]);
  }, [W9FormDetail]);

  const handleDownloadW9 = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "W9-Form.pdf";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const panellistW9FormDetailsDataColumn = (data) => {
  //   const timeout = setTimeout(() => {
  //     let myFilterObject1 = [];
  //     const entries = Object.entries(data[0]);
  //     for (let [key, row] of entries) {
  //       let isExits = w9FormRemoveObj.includes(key);
  //       if (!isExits) {
  //         if (key != "createdAt" && key != "updatedAt") {
  //           myFilterObject1.push({
  //             name: key,
  //             selector: () =>
  //               row === null ? (
  //                 "--"
  //               ) : key === "ssn" ? (
  //                 <CustomTooltip title={row || "--"} childrenText={row} />
  //               ) : (
  //                 row
  //               ),
  //             sortable: true,
  //           });
  //         }
  //         if (key == "createdAt" || key == "updatedAt") {
  //           myFilterObject1.push({
  //             name: key,
  //             selector: () =>
  //               row == null ? "--" : moment(row).format("YYYY-MM-DD"),
  //             sortable: true,
  //             width: "12%",
  //           });
  //         }
  //       }
  //     }
  //     myFilterObject1.push({
  //       name: "w9Form",
  //       cell: (row) => (
  //         <>
  //           <div>
  //             <Stack direction={"row"}>
  //               <Tooltip title="Download">
  //                 <IconButton>
  //                   <Download
  //                     onClick={() => {
  //                       {
  //                         window.open(data[0].fw9Url);
  //                       }
  //                     }}
  //                   />
  //                 </IconButton>
  //               </Tooltip>
  //             </Stack>
  //           </div>{" "}
  //         </>
  //       ),
  //     });

  //     setW9FormColumns(myFilterObject1);
  //     setPending(false);
  //   }, 1000);
  // };

  const handleToggleCheckBox = (e, value) => {
    if (panelistData?.isEmailVerified == false) {
      panelistData.isEmailVerified = true;
    } else {
      panelistData.isEmailVerified = false;
    }

    const { name } = e.target;
    setPanelistData((prev) => ({
      ...prev,
      [name]: Boolean(value),
    }));
  };

  const handleToggleSubscribeCheckBox = (e, value) => {
    if (panelistData?.unsubscribe == false) {
      panelistData.unsubscribe = true;
    } else {
      panelistData.unsubscribe = false;
    }
    const { name } = e.target;
    setPanelistData((prev) => ({
      ...prev,
      [name]: Boolean(value),
    }));
  };

  const handleToggleSampleAllowCheckBox = (e, value) => {
    if (panelistData?.isSampleAllow == false) {
      panelistData.isSampleAllow = true;
    } else {
      panelistData.isSampleAllow = false;
    }
    const { name } = e.target;
    setPanelistData((prev) => ({
      ...prev,
      [name]: Boolean(value),
    }));
  };

  const handleToggleIsActiveCheckBox = (e, value) => {
    if (panelistData?.isActive == false) {
      panelistData.isActive = true;
    } else {
      panelistData.isActive = false;
    }
    const { name } = e.target;
    setPanelistData((prev) => ({
      ...prev,
      [name]: Boolean(value),
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPanelistData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const zipValidateMatch = (value, duplicate) => {
    let zipPatternObjects = validationPatterns.filter((e) =>
      e.countryids.find((l) => l === panelistData.countryId),
    );
    let regexForZip = new RegExp(zipPatternObjects[0].patterns[0]);
    if (!regexForZip.test(value.toUpperCase())) {
      duplicate["zipCode"] =
        "Please enter valid postal code in this format:" +
        zipPatternObjects[0].message;
      setvalidationError((prev) => ({
        ...prev,
        ["zipCode"]:
          "Please enter valid postal code in this format:" +
          zipPatternObjects[0].message,
      }));
    }
  };

  const handleValidInputChange = (e) => {
    const { name, value } = e.target;
    console.log("Input Changed:", name, value);
    let duplicate = { ...validationError };
    setPanelistData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setvalidationError((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "zipCode") {
      if (e.target.value === "") {
        duplicate["zipCode"] = "Zipcode is required";
        setvalidationError((prev) => ({
          ...prev,
          [name]: "Zipcode is required",
        }));
      } else {
        zipValidateMatch(e.target.value, duplicate);
      }
    }
  };

  const handleUpdateSubmit = () => {
    let duplicate = { ...validationError };

    if (panelistData.email === "") {
      duplicate["email"] = "Email Id is required";
    } else if (panelistData.email !== "") {
      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(panelistData.email)
      ) {
        duplicate["email"] = "Invalid Email Id";
      }
    }
    if (panelistData.zipCode === "") {
      duplicate["zipCode"] = "Zipcode is required";
    } else if (panelistData.zipCode !== "") {
      zipValidateMatch(panelistData.zipCode, duplicate);
    }

    setvalidationError(duplicate);

    const noError = Object.values(duplicate).every(
      (x) => x === null || x === "",
    );
    if (!noError) {
      return;
    }

    const requestData = {
      email: panelistData.email?.toLowerCase(),
      dob: moment(panelistData.dob).format("YYYY-MM-DD"),
      zip: panelistData.zipCode,
      isEmailVerified: panelistData.isEmailVerified,
      unsubscribe: panelistData.unsubscribe,
      panelistId: parseInt(id),
      isActive: panelistData.isActive,
      isSampleAllow: panelistData.isSampleAllow,
      userType: selectedUserType.userType,
      deleteReason: panelistData.deleteReason,
      levelId: levelItem.id,
      categoryType: categoryItem.id,
    };
    setIsDisableUpdate(true);
    updatePanelist(requestData)
      .then((res) => {
        if (res?.data) {
          setAlert(res.data.message);
          setIsDisableUpdate(false);

          getPanelistById(panelistId)
            .then((res) => {
              if (res?.status === 200) {
                res.data.data[0].dob = moment(res.data.data[0]?.dob).format(
                  "YYYY-MM-DD",
                );
                res.data.data[0].joinDate = moment(
                  res.data.data[0]?.joinDate,
                ).format("YYYY-MM-DD");

                res.data.data[0].emailVerifyDate =
                  res.data.data[0]?.emailVerifyDate != null
                    ? moment(res.data.data[0]?.emailVerifyDate).format(
                        "YYYY-MM-DD",
                      )
                    : null;
                res.data.data[0].unsubscribeDate =
                  res.data.data[0]?.unsubscribeDate != null
                    ? moment(res.data.data[0]?.unsubscribeDate).format(
                        "YYYY-MM-DD",
                      )
                    : null;

                setPanelistData(res.data.data[0]);
              }
            })
            .catch((err) => {
              // console.log(err);
              setAlert("Somthing went wrong");
            });
        }
      })
      .catch((err) => {
        // console.log(err);
        setAlert("Somthing went wrong");
      });
  };

  const handleCloseAlert = () => {
    setAlert(false);
  };

  const renderSurveyTimeCalculation = (startDate, endDate) => {
    if (endDate != null) {
      let totalMinutes = moment
        .utc(endDate)
        .diff(moment.utc(startDate), "minutes");
      let totalSeconds = moment
        .utc(endDate)
        .diff(moment.utc(startDate), "seconds");

      const minutesInDay = 24 * 60;
      let days = Math.floor(totalMinutes / minutesInDay);
      let remainingMinutes = totalMinutes % minutesInDay;
      let hours = Math.floor(remainingMinutes / 60);
      let minutes = remainingMinutes % 60;

      let combineString = "";
      if (days > 0) {
        combineString += days + " days ,";
      }
      if (hours > 0) {
        combineString += hours + " hrs ,";
      }
      if (minutes > 0) {
        combineString += minutes + " min ";
      }

      if (combineString === "") {
        combineString += totalSeconds + " seconds ";
      }
      return combineString;
    } else {
      return "--";
    }
  };

  const handleCopy = (text) => {
    copyToClipboard(text, (message) => {
      setAlert(message);
    });
  };

  return (
    <>
      <SnackBarAlert
        id="divSnackBar"
        open={alert}
        handleClose={handleCloseAlert}
      />
      <Stack direction={"row"} alignItems={"flex-start"}>
        <Paper elevation={2} sx={{ my: 2, p: 2, mr: 2, width: "100%" }}>
          <Grid container sx={{ mb: 2 }} justifyContent={"end"}>
            <Grid
              item
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={() => handleActivityHistory()}
                sx={{
                  fontSize: "15px",
                  textTransform: "none",
                }}
              >
                <HistoryIcon fontSize="small" sx={{mr:0.5}} /> Activity Log
              </Button>
              <Button
                size="small"
                variant="contained"
                onClick={() => handleLoginHistory()}
                sx={{
                  fontSize: "15px",
                  textTransform: "none",
                  backgroundColor: "#2e7d32", // Green
                  "&:hover": {
                    backgroundColor: "#1b5e20",
                  },
                }}
              >
               <LoginIcon fontSize="small" sx={{mr:0.5}} />  Login History
              </Button>
            </Grid>
          </Grid>
          <div className="panelistFormDiv">
            <Accordion
              sx={{ my: 1, p: 0.5, mr: 1, width: "100%" }}
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h6">
                  Panelist Personal Details - ({panelistId})
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columnSpacing={{ xs: 2, md: 15 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  sx={{ mb: 4 }}
                >
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"firstName"}
                      className="copiedInput"
                      value={panelistData.firstName}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                        pointerEvents: "none",
                      }}
                      label={"First Name"}
                      InputProps={{
                        endAdornment: (
                          <Tooltip title="Copy to clipboard">
                            <IconButton
                              onClick={() => handleCopy(panelistData.firstName)}
                              style={{ pointerEvents: "auto" }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"lastName"}
                      value={panelistData.lastName}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Last Name"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <FormControl fullWidth>
                      {/* <InputLabel id="gender-label">Gender</InputLabel> */}
                      {/* <Select labelId="gender-label" id="gender" value={panelistData.gender} label="Gender"
                        className="disableField"
                        onChange={(event) =>
                          setPanelistData((prevState) => ({
                            ...prevState,
                            gender: event.target.value,
                          }))}>
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                      </Select> */}

                      <TextField
                        labelId="gender-label"
                        id="gender"
                        fullWidth
                        multiline
                        name={"Gender"}
                        value={panelistData.gender}
                        type={"text"}
                        className="disableField"
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "2px solid #f0f0f0",
                          },
                        }}
                        label="Gender"
                        InputLabelProps={{ shrink: true }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      id="txtDob"
                      fullWidth
                      name={"dob"}
                      InputProps={{
                        inputProps: { max: moment().format("YYYY-MM-DD") },
                      }}
                      value={panelistData.dob}
                      type={"date"}
                      onChange={handleInputChange}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"DOB"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Age"}
                      value={panelistData.age}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Age"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"email"}
                      value={panelistData.email}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Email ID"}
                      error={Boolean(validationError.email)}
                      helperText={validationError.email}
                      onChange={handleValidInputChange}
                      InputProps={{
                        endAdornment: (
                          <Tooltip title="Copy to clipboard">
                            <IconButton
                              onClick={() => handleCopy(panelistData.email)}
                              style={{ pointerEvents: "auto" }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Previous Email ID"}
                      value={panelistData.prevEmail}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Previous Email ID"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"zipCode"}
                      value={panelistData.zipCode}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Zipcode"}
                      error={Boolean(validationError.zipCode)}
                      helperText={validationError.zipCode}
                      onChange={handleValidInputChange}
                      inputProps={{ maxLength: zipMaxLength }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Mobile no"}
                      value={panelistData.mobile}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label="Mobile No"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <div className="disableField">
                      <AsyncDropdown
                        value={selectedCountry}
                        options={countries}
                        objKey={"countryName"}
                        stylized
                        label={"Country"}
                        handleChange={(value) =>
                          handleDropDownChange(value, dropDowns.COUNTRY)
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <div className="disableField">
                      <AsyncDropdown
                        value={selectedLanguage}
                        options={languages}
                        objKey={"language"}
                        stylized
                        label={"Language"}
                        handleChange={(value) =>
                          handleDropDownChange(value, dropDowns.LANGUAGE)
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"currency"}
                      value={panelistData.currency}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Currency"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"address"}
                      value={panelistData.address}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Address"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"state"}
                      value={panelistData.state}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"State"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"city"}
                      value={panelistData.city}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"City"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"joinIp"}
                      value={panelistData.joinIp}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Join Ip"}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"joinDate"}
                      value={panelistData.joinDate}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Join Date"}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"emailVerifyDate"}
                      className="disableField"
                      value={panelistData.emailVerifyDate}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Email Verify Date"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"sourceName"}
                      value={panelistData?.sourceName}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Source"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"device"}
                      className="disableField"
                      value={panelistData.device}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Device Type"}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"UnsubscribeDate"}
                      value={panelistData?.unsubscribeDate}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Unsubscribe Date"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Reconcile"}
                      value={reconcile}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Reconcile"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Reconcile Rate"}
                      value={reconcileRate}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Reconcile Rate"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Reconcile Cost"}
                      value={Points.totalReconcilePoints}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Reconcile Cost"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Revenue"}
                      value={revenue}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Revenue"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Total Cost"}
                      value={totalcost}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Total Cost"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Profit"}
                      value={profit}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Profit"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Terminate Cost"}
                      value={Points.totalTerminateCost}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Terminate Cost"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Fraud Score
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title={"Email Fraud Score"}
                            arrow
                          >
                            <Typography>
                              {panelistData?.emailScore ?? 0}
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title={"IPQS Fraud Score"}
                            arrow
                          >
                            <Typography>
                              {panelistData?.ipFraudScore ?? 0}
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"visitorID"}
                      value={panelistData?.visitorID}
                      className="copiedInput"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                        pointerEvents: "none",
                      }}
                      label={"Visitor ID"}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (
                          <Tooltip title="Copy to clipboard">
                            <IconButton
                              onClick={() => handleCopy(panelistData.visitorID)}
                              style={{ pointerEvents: "auto" }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <div>
                      <AsyncDropdown
                        value={selectedUserType}
                        options={userTypes}
                        objKey={"userType"}
                        stylized
                        label={"User Type"}
                        InputLabelProps={{ shrink: true }}
                        id="divUserType"
                        handleChange={(value) =>
                          handleDropDownChange(value, dropDowns.USERTYPE)
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Conversion"}
                      value={conversion}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Conversion"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <AsyncDropdown
                      handleChange={(value) => handleLevelChange(value)}
                      value={levelItem}
                      options={levelList}
                      objKey={"levelName"}
                      stylized
                      label={"Select Level"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <AsyncDropdown
                      handleChange={(value) => handleCategoryChange(value)}
                      value={categoryItem}
                      options={categoryList}
                      objKey={"categoryType"}
                      stylized
                      label={"Select Category"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"paypalEmail"}
                      value={panelistData?.paypalEmail}
                      className="copiedInput"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                        pointerEvents: "none",
                      }}
                      label={"Paypal Email"}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (
                          <Tooltip title="Copy to clipboard">
                            <IconButton
                              onClick={() =>
                                handleCopy(panelistData.paypalEmail)
                              }
                              style={{ pointerEvents: "auto" }}
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </Tooltip>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <Tooltip
                      title={panelistData?.deleteReason || ""}
                      placement="top"
                      disableHoverListener={!panelistData?.deleteReason} // Disables Tooltip when deleteReason is empty
                    >
                      <div>
                        <TextField
                          fullWidth
                          name="deleteReason"
                          value={panelistData?.deleteReason || ""}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "2px solid #f0f0f0",
                            },
                          }}
                          label="Reason"
                          onChange={handleValidInputChange}
                        />
                      </div>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <Tooltip
                      title={panelistData?.description || ""}
                      placement="top"
                      disableHoverListener={!panelistData?.description} // Disables Tooltip when description is empty
                    >
                      <div>
                        <TextField
                          fullWidth
                          name="promoCode"
                          value={panelistData?.promoCode || ""}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "2px solid #f0f0f0",
                            },
                          }}
                          label="Promo Code"
                          className="disableField"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                onClick={() =>
                                  handleCopy(panelistData.promoCode)
                                }
                                style={{ pointerEvents: "auto" }}
                              >
                                <ContentCopyIcon />
                              </IconButton>
                            ),
                          }}
                        />
                      </div>
                    </Tooltip>
                  </Grid>
                   <Grid item xs={2} sm={4} md={4}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Profile Completions
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title={"Answered question percentage"}
                            arrow
                          >
                           <Typography>
                              {(() => {
                                const value = Number(questionPercentage?.profilePercentage ?? 0);
                                return Number.isInteger(value) ? value : value.toFixed(2);
                              })()} %
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip placement="top" title={"Last Updated date"} arrow>
                            <Typography>{moment(new Date(questionPercentage?.lastUpdated ?? new Date())).format("YYYY-MM-DD")}</Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  

                  <Grid item xs={4} sm={12} md={12}>
                    <Checkbox
                      id="checkEmailVerify"
                      onChange={handleToggleCheckBox}
                      checked={panelistData?.isEmailVerified}
                    />
                    <span>Email Verified</span>
                    <Checkbox
                      id="checkSubscribe"
                      onChange={handleToggleSubscribeCheckBox}
                      checked={panelistData?.unsubscribe}
                    />
                    <span>Unsubscribe</span>

                    <Checkbox
                      id="checkSampleAllow"
                      onChange={handleToggleSampleAllowCheckBox}
                      checked={panelistData?.isSampleAllow}
                    />
                    <span>Sample Allow</span>
                    <Checkbox
                      id="checkSubscribe"
                      onChange={handleToggleIsActiveCheckBox}
                      checked={panelistData?.isActive}
                    />
                    <span>Active</span>

                    <Grid
                      container
                      spacing={{ xs: 2, md: 3 }}
                      columnSpacing={{ xs: 2, md: 15 }}
                      columns={{ xs: 4, sm: 8, md: 12 }}
                      sx={{ mb: 4 }}
                    >
                      <Grid item xs={4} sm={4} md={4}></Grid>
                      <Grid item xs={4} sm={4} md={4}></Grid>

                      <Grid item xs={4} sm={4} md={4}>
                        {!isDisableUpdate ? (
                          <ConfirmAlert
                            onClickEvent={() => handleUpdateSubmit()}
                            msg={"Are you sure want to update panelist?"}
                          >
                            <LoadingButton
                              variant="contained"
                              sx={{ px: 4, textTransform: "capitalize", my: 1 }}
                            >
                              Update Panelist
                            </LoadingButton>
                          </ConfirmAlert>
                        ) : (
                          <LoadingButton
                            variant="contained"
                            sx={{ px: 4, textTransform: "capitalize", my: 1 }}
                            disabled={isDisableUpdate}
                          >
                            Update Panelist
                          </LoadingButton>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid></Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {panelistData?.countryId === 4 ? (
              <>
                <Accordion sx={{ my: 2, p: 0.5, mr: 2, width: "100%" }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-content"
                    id="panel-header"
                  >
                    <Typography variant="h6">
                      Panelist W9Form Details:
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="data-table w9-Table">
                      <CustomDataTable
                        columns={w9FormColumns}
                        data={W9FormDetail}
                        pagination={true}
                        progressPending={pendingW9Action}
                        highlightOnHover
                        progressComponent={<CircularProgress />}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <ConfirmAlert
                    msg="Are you sure you want to validate the W-9 form?"
                    onClickEvent={() => {
                      handleW9Form(selectedRow, 1);
                      handleMenuClose();
                    }}
                  >
                    <MenuItem>
                      <ListItemIcon>
                        <Done fontSize="small" color="success" />
                      </ListItemIcon>
                      <ListItemText>Verify</ListItemText>
                    </MenuItem>
                  </ConfirmAlert>

                  <ConfirmAlert
                    msg="Are you sure you want to mark the W-9 form as invalid?"
                    onClickEvent={() => {
                      handleW9Form(selectedRow, 2);
                      handleMenuClose();
                    }}
                  >
                    <MenuItem>
                      <ListItemIcon>
                        <Close fontSize="small" color="error" />
                      </ListItemIcon>
                      <ListItemText>Invalid</ListItemText>
                    </MenuItem>
                  </ConfirmAlert>

                  <MenuItem
                    onClick={() => {
                      handleW9Form(selectedRow, 3);
                      handleMenuClose();
                    }}
                  >
                    <ListItemIcon>
                      <PauseCircle fontSize="small" color="warning" />
                    </ListItemIcon>
                    <ListItemText>Pending</ListItemText>
                  </MenuItem>
                </Menu>
              </>
            ) : (
              ""
            )}

            <Accordion sx={{ my: 2, p: 0.5, mr: 2, width: "100%" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h6">Panelist Points Details:</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {/* parent Div */}
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  sx={{ mb: 4 }}
                >
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                        }}
                      >
                        Total Earned Points
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>{Points.totalPoints ?? 0}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Total Points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",

                          fontSize: "0.75rem",
                        }}
                      >
                        Complete
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>
                            {Points.totalSurveyPoint ?? 0}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Survey Complete points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",

                          fontSize: "0.75rem",
                        }}
                      >
                        Referral
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>
                            {Points.totalRefferalPoint ?? 0}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Referral Points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Mini Survey
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>
                            {Points.totalMiniSurveyPoint ?? 0}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Mini Survey points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Terminate
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>
                            {Points.totalTerminatePoint ?? 0}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Terminate points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Joining bonus
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title={"Joining Bonus Points"}
                            arrow
                          >
                            <Typography>{Points.joiningPoint ?? 0}</Typography>
                          </Tooltip>
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip placement="top" title={"Promo Points"} arrow>
                            <Typography>{Points.promoPoint ?? 0}</Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Joining Bonus */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Leaderboard
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip placement="top" title={"Daily Winner"} arrow>
                            <Typography>{Points.dailyWinner ?? 0}</Typography>
                          </Tooltip>
                        </Box>

                        <Divider orientation="vertical" flexItem />

                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Tooltip
                            placement="top"
                            title={"Monthly Winner"}
                            arrow
                          >
                            <Typography>{Points.monthlyWinner ?? 0}</Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Leaderboard Points */}
                  <Grid item xs={4} sm={3} md={3}>
                    <Box
                      sx={{
                        position: "relative",
                        border: "2px solid #f0f0f0",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      {/* Floating Label */}
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: "-10px",
                          left: "12px",
                          backgroundColor: "#fff",
                          paddingX: "4px",
                          color: "#888",
                          fontSize: "0.75rem",
                        }}
                      >
                        Others
                      </Typography>

                      {/* Two inner boxes */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "16px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          }}
                        >
                          <Typography>
                            <Tooltip
                              placement="top"
                              title={Object.entries(Points?.otherPoints || {})
                                .filter(([_, value]) => value > 0)
                                .map(([key]) => key)
                                .join(", ")}
                              arrow
                            >
                              <Typography>
                                {Object.values(Points?.otherPoints || {})
                                  .filter((value) => value > 0)
                                  .reduce((sum, value) => sum + value, 0)}
                              </Typography>
                            </Tooltip>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>{" "}
                  {/* Others points */}
                </Grid>

                <div className="data-table">
                  <CustomDataTable
                    columns={columns}
                    data={filteredPointsDetail}
                    pagination={true}
                    progressPending={pending}
                    highlightOnHover
                  />
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion sx={{ my: 2, p: 0.5, mr: 2, width: "100%" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h6">
                  Survey Participation Details:
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columnSpacing={{ xs: 2, md: 15 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  sx={{ mb: 4 }}
                >
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      name={"Total Attempts"}
                      value={SurveyPoints.totalAttempts}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Total Attempts"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Completes"}
                      value={SurveyPoints.completes}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Completes"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Terminates"}
                      value={SurveyPoints.terminates}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Terminates"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Quota Full"}
                      value={SurveyPoints.quotaFull}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Quota Full"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"InCompletes"}
                      value={SurveyPoints.inCompletes}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"InCompletes"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Reconcile"}
                      value={SurveyPoints?.reconcile}
                      className="disableField"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Reconcile"}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columnSpacing={{ xs: 2, md: 15 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  sx={{ mb: 2 }}
                ></Grid>
                <div className="data-table">
                  <CustomDataTable
                    columns={surveyColumns}
                    data={filteredSurveyPointsDetail}
                    pagination={true}
                    progressPending={pending}
                    highlightOnHover
                  />
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion sx={{ my: 2, p: 0.5, mr: 2, width: "100%" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
              >
                <Typography variant="h6">Redemption Details:</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columnSpacing={{ xs: 2, md: 15 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  sx={{ mb: 4 }}
                >
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Total Points"}
                      className="disableField"
                      value={
                        RedemptionPoints.totalPoints > 0
                          ? RedemptionPoints.totalPoints +
                            "($" +
                            Math.round(RedemptionPoints.totalPoints) /
                              redemptionPointDivider +
                            ")"
                          : 0
                      }
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Total Point"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Points Redeemed"}
                      className="disableField"
                      value={
                        RedemptionPoints.pointredeemed > 0
                          ? RedemptionPoints.pointredeemed +
                            "($" +
                            Math.round(RedemptionPoints.pointredeemed) /
                              redemptionPointDivider +
                            ")"
                          : 0
                      }
                      // value={RedemptionPoints.pointredeemed}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Points Redeemed"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Balance Points"}
                      className="disableField"
                      value={
                        RedemptionPoints.balancepoints +
                        "($" +
                        Math.round(RedemptionPoints.balancepoints) /
                          redemptionPointDivider +
                        ")"
                      }
                      // value={RedemptionPoints.balancepoints}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Balance Points"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Approved Point"}
                      className="disableField"
                      value={
                        RedemptionPoints.approvedPoints > 0
                          ? RedemptionPoints.approvedPoints +
                            "($" +
                            Math.round(RedemptionPoints.approvedPoints) /
                              redemptionPointDivider +
                            ")"
                          : 0
                      }
                      // value={RedemptionPoints.approvedPoints}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Approved Point"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Rejected Point"}
                      className="disableField"
                      value={
                        RedemptionPoints.rejectedPoints > 0
                          ? RedemptionPoints.rejectedPoints +
                            "($" +
                            Math.round(RedemptionPoints.rejectedPoints) /
                              redemptionPointDivider +
                            ")"
                          : 0
                      }
                      // value={RedemptionPoints.rejectedPoints}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Rejected Point"}
                    />
                  </Grid>
                  <Grid item xs={2} sm={4} md={4}>
                    <TextField
                      fullWidth
                      multiline
                      name={"Pending Point"}
                      className="disableField"
                      value={
                        RedemptionPoints.pendingPoints > 0
                          ? RedemptionPoints.pendingPoints +
                            "($" +
                            Math.round(RedemptionPoints.pendingPoints) /
                              redemptionPointDivider +
                            ")"
                          : 0
                      }
                      // value={RedemptionPoints.pendingPoints}
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid #f0f0f0",
                        },
                      }}
                      label={"Pending Point"}
                    />
                  </Grid>
                </Grid>
                <div className="data-table redeemTable">
                  <CustomDataTable
                    columns={redeemColumns}
                    data={RedemptionPointsDetail}
                    pagination={true}
                    progressPending={pending}
                    highlightOnHover
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <Popover
            open={Boolean(surveyCodeAnchorEl)}
            anchorEl={surveyCodeAnchorEl}
            onClose={() => {
              setSurveyCodeAnchorEl(null);
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            sx={{ zIndex: 9999 }}
          >
            <Box sx={{ p: 1.5, minWidth: "200px" }}>
              <Typography
                sx={{ fontSize: "12px", fontWeight: 600, color: "#555", mb: 1 }}
              >
                Search Survey Code
              </Typography>
              <TextField
                size="small"
                placeholder="Enter survey code..."
                value={surveyCodeSearch}
                autoFocus
                onChange={(e) => setSurveyCodeSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setAppliedSurveyCode(surveyCodeSearch); // Enter press par bhi apply ho
                    setSurveyCodeAnchorEl(null);
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: "16px", color: "#999" }} />
                    </InputAdornment>
                  ),
                  endAdornment: surveyCodeSearch ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setSurveyCodeSearch("")}
                      >
                        <CloseIcon sx={{ fontSize: "14px" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                fullWidth
              />
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "flex-end",
                  mt: 1,
                }}
              >
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setSurveyCodeSearch("");
                    setAppliedSurveyCode("");
                    setSurveyCodeAnchorEl(null);
                  }}
                  sx={{ fontSize: "11px", textTransform: "none" }}
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setAppliedSurveyCode(surveyCodeSearch);
                    setSurveyCodeAnchorEl(null);
                  }}
                  sx={{ fontSize: "11px", textTransform: "none" }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Popover>

          {/* ─── Activity Log Popup ──────────────────────────────────── */}
          <Dialog
            open={openActivityLog}
            onClose={() => setOpenActivityLog(false)}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: { borderRadius: 3 } }}
          >
            {/* Header */}
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                pb: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <HistoryIcon fontSize="small" />
                <Typography fontWeight={500} fontSize={16}>
                  Activity Log
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => setOpenActivityLog(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            {/* Log List */}
              <DialogContent dividers sx={{ p: 0 }}>
                {paginatedActivityHistory.length > 0 ? (
                  <List disablePadding>
                    {paginatedActivityHistory.map((log, index) => (
                      <ListItem
                        key={log.id || index}
                        divider
                        alignItems="flex-start"
                        sx={{ px: 2.5, py: 1.5, gap: 1.5 }}
                      >
                        <Avatar
                          sx={{
                            width: 34,
                            height: 34,
                            bgcolor: log.email ? "#EEEDFE" : "#E1F5EE",
                            color: log.email ? "#534AB7" : "#0F6E56",
                            mt: 0.3,
                            fontSize: 24,
                          }}
                        >
                          {log.email && <AdminPanelSettingsIcon />}
                        </Avatar>

                        <Box flex={1}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            gap={0.8}
                            flexWrap="wrap"
                          >
                            <Typography fontSize={13} fontWeight={500}>
                              {(log.fieldName || "").toUpperCase()}
                            </Typography>
                            {log.email && (
                              <Chip
                                label={"Admin: " + log.email}
                                size="small"
                                color="info"
                                sx={{ fontSize: 10, height: 18 }}
                              />
                            )}
                          </Stack>

                          <Stack
                            direction="row"
                            gap={1.5}
                            mt={0.4}
                            flexWrap="wrap"
                            alignItems="center"
                          >
                            <Typography
                              fontSize={12}
                              color="text.secondary"
                              sx={{ display: "flex", alignItems: "center", gap: 0.4 }}
                            >
                              <AccessTimeIcon sx={{ fontSize: 13 }} />
                              {moment(log.createdAt).format("DD MMMM YYYY, hh:mm A")}
                            </Typography>
                            <Chip
                              label={`Old Value : ${String(log.oldValue ?? "N/A")}`}
                              size="small"
                              color="primary"
                              sx={{
                                height: 18,
                                "& .MuiChip-label": { fontSize: "11px", px: 0.8 },
                              }}
                            />
                            <Chip
                              label={`New Value : ${String(log.newValue ?? "N/A")}`}
                              size="small"
                              color="primary"
                              sx={{
                                height: 18,
                                "& .MuiChip-label": { fontSize: "11px", px: 0.8 },
                              }}
                            />
                          </Stack>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Stack alignItems="center" gap={0.8} flexWrap="wrap">
                    <Typography fontSize={18} fontWeight={500} padding={4}>
                      📝 {activityLogMessage}
                    </Typography>
                  </Stack>
                )}
              </DialogContent>

            {activityLogs.length > 0 && (
              <TablePagination
                component="div"
                count={activityLogs.length}
                page={activityPage}
                onPageChange={handleActivityPageChange}
                rowsPerPage={activityRowsPerPage}
                onRowsPerPageChange={handleActivityRowsPerPageChange}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Rows"
                sx={{
                  flexShrink: 0, // yahi asli fix hai, ab ye kabhi chhota nahi hoga
                  borderTop: 1,
                  borderColor: "divider",
                  overflow: "hidden",
                  p: 0,
                  ".MuiTablePagination-toolbar": {
                    minHeight: 48,
                    height: 48,
                    pl: 2,
                    pr: 1.5,
                    justifyContent: "flex-start",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                    {
                      fontSize: 14,
                      m: 0,
                    },
                  ".MuiTablePagination-select": {
                    fontSize: 14,
                    minWidth: 32,
                  },
                  ".MuiTablePagination-input": {
                    mr: 1.5,
                    ml: 0.5,
                  },
                  ".MuiTablePagination-displayedRows": {
                    mr: 1,
                  },
                  ".MuiTablePagination-actions": {
                    ml: 0.5,
                  },
                }}
              />
            )}

            {/* Footer */}
            <DialogActions>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setOpenActivityLog(false)}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* ─── Login History Popup ─────────────────────────────────── */}
          <Dialog
            open={openLoginHistory}
            onClose={() => setOpenLoginHistory(false)}
            fullWidth
            maxWidth="sm"
            PaperProps={{
              sx: {
                borderRadius: 3,
                height: "90vh", // fixed height, taaki size kabhi na badle
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            {/* Header */}
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                pb: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LoginIcon fontSize="small" />
                <Typography fontWeight={500} fontSize={16}>
                  {historyTab === 0
                    ? "Login History"
                    : "Verisoul History"}
                </Typography>
              </Box>
              <IconButton
                size="small"
                onClick={() => setOpenLoginHistory(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            {/* Nav Buttons (Tabs) */}
            <Tabs
              value={historyTab}
              onChange={(e, newValue) => setHistoryTab(newValue)}
              variant="fullWidth"
              sx={{
                px: 2,
                borderBottom: 1,
                borderColor: "divider",
                minHeight: 40,
                "& .MuiTab-root": {
                  minHeight: 40,
                  fontSize: 16,
                  fontWeight: 600,
                  textTransform: "none",
                },
              }}
            >
              <Tab label="Login History" />
              <Tab label="Verisoul History" />
            </Tabs>

            <DialogContent dividers sx={{ p: 0 }}>
              {/* ───────────── TAB 0 : LOGIN HISTORY ───────────── */}
              {historyTab === 0 && (
                <>
                  {paginatedLoginHistory.length > 0 ? (
                    paginatedLoginHistory.map((item, index) => {
                      const globalIndex = loginPage * loginRowsPerPage + index;
                      return (
                        <Box key={item.id || globalIndex}>
                          <Typography
                            fontSize={11}
                            fontWeight={600}
                            color="text.secondary"
                            sx={{
                              px: 2.5,
                              py: 0.8,
                              bgcolor: "action.hover",
                              textTransform: "uppercase",
                              letterSpacing: 0.4,
                            }}
                          >
                            {moment(item.createdAt).format("DD MMMM YYYY")}
                          </Typography>

                          <ListItem divider sx={{ px: 2.5, py: 1.2, gap: 1.5 }}>
                            <Avatar
                              variant="rounded"
                              sx={{
                                width: 52,
                                height: 36,
                                bgcolor: "action.hover",
                                color: "text.primary",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 1,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 13,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                {item.panelistCountry}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: 8,
                                  lineHeight: 1,
                                  color: "text.secondary",
                                  textAlign: "center",
                                  mt: 0.2,
                                }}
                              >
                                User Country
                              </Typography>
                            </Avatar>

                            <Box flex={1} gap={1}>
                              <Typography fontSize={13} fontWeight={500}>
                                Login Country ( {item.ipCountryCode} -{" "}
                                {item.ipAddress} )
                              </Typography>

                              <Stack
                                direction="row"
                                gap={1.5}
                                mt={0.3}
                                flexWrap="wrap"
                                alignItems="center"
                              >
                                <Typography
                                  fontSize={12}
                                  color="text.secondary"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.4,
                                  }}
                                >
                                  <Chip
                                    label={`VPN : ${String(item.vpn)}`}
                                    size="small"
                                    color="primary"
                                    sx={{
                                      height: 18,
                                      "& .MuiChip-label": {
                                        fontSize: "11px", // ya 9px, 11px
                                        px: 0.8,
                                      },
                                    }}
                                  />
                                  <Chip
                                    label={`Proxy : ${String(item.proxy)}`}
                                    size="small"
                                    color="primary"
                                    sx={{
                                      height: 18,
                                      "& .MuiChip-label": {
                                        fontSize: "11px", // ya 9px, 11px
                                        px: 0.8,
                                      },
                                    }}
                                  />
                                  <Chip
                                    label={`Fraud Score : ${String(item.fraudScore)}`}
                                    size="small"
                                    color="primary"
                                    sx={{
                                      height: 18,
                                      "& .MuiChip-label": {
                                        fontSize: "11px", // ya 9px, 11px
                                        px: 0.8,
                                      },
                                    }}
                                  />
                                </Typography>

                                <Typography
                                  fontSize={12}
                                  color="text.secondary"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.4,
                                  }}
                                >
                                  <AccessTimeIcon sx={{ fontSize: 13 }} />
                                  {new Date(item.createdAt).toLocaleTimeString(
                                    "en-IN",
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    },
                                  )}
                                </Typography>

                                {globalIndex === 0 && (
                                  <Chip
                                    label="Current Session"
                                    size="small"
                                    color="secondary"
                                  />
                                )}
                              </Stack>
                            </Box>
                          </ListItem>
                        </Box>
                      );
                    })
                  ) : (
                    <Stack alignItems="center" gap={0.8} flexWrap="wrap">
                      <Typography fontSize={18} fontWeight={500} padding={4}>
                        📝 {loginMessage}
                      </Typography>
                    </Stack>
                  )}
                </>
              )}

              {/* ───────────── TAB 1 : VARISOUL STATUS HISTORY ───────────── */}
              {historyTab === 1 && (
                <>
                  {varisoulHistory.length > 0 ? (
                    varisoulHistory.map((item, index) => (
                      <Box key={item.id || index}>
                        <Stack
                            direction="row"
                            alignItems="center"
                          >
                            <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              px: 2.5,
                              py: 0.8,
                              bgcolor: "action.hover",
                              borderColor: "divider",
                            }}
                          >
                            {/* Date */}
                            <Typography
                              component="span"
                              fontSize={11}
                              fontWeight={600}
                              color="text.secondary"
                              sx={{ textTransform: "uppercase", letterSpacing: 0.4, whiteSpace: "nowrap" }}
                            >
                              {moment(item?.updatedAt).format("DD MMMM YYYY")}
                            </Typography>

                            {/* Time */}
                            <Typography
                              component="span"
                              fontSize={11}
                              fontWeight={600}
                              color="text.secondary"
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                letterSpacing: 0.4,
                                whiteSpace: "nowrap",
                              }}
                            >
                              <AccessTimeIcon sx={{ fontSize: 14 }} />
                              {new Date(item?.updatedAt).toLocaleTimeString("en-IN", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </Typography>
                          </Box>
                          </Stack>

                        <ListItem divider sx={{ px: 2.5, py: 1.2, gap: 1.5 }}>
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 52,
                              height: 36,
                              bgcolor: "action.hover",
                              color: "text.primary",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: 13,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              {item?.accountScore}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: 8,
                                lineHeight: 1,
                                color: "text.secondary",
                                textAlign: "center",
                                mt: 0.2,
                              }}
                            >
                              Verisoul Score
                            </Typography>
                          </Avatar>

                          <Box flex={1} gap={1}>
                             <Stack 
                              direction="row"
                              gap={1.5}
                              mt={0.3}
                              flexWrap="wrap"
                              alignItems="center">
                              <Typography fontSize={13} fontWeight={500}>
                              True Country ( <Flag size={18} code={item?.trueCountryCode.toLowerCase() || ''} /> {item.trueCountryCode || 'N/A'} )
                            </Typography>
                            <Typography fontSize={13} fontWeight={500}>
                              IP Country ( <Flag size={18} code={item?.countryCode.toLowerCase() || ''} /> {item.countryCode || 'N/A'} )
                            </Typography>
                             </Stack>

                            <Stack
                              direction="row"
                              gap={1.5}
                              mt={0.3}
                              flexWrap="wrap"
                              alignItems="center"
                            >
                              <Typography
                                fontSize={12}
                                color="text.secondary"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.4,
                                }}
                              >
                                <Chip
                                  label={`VPN : ${String(item?.isVPN)}`}
                                  size="small"
                                  color="primary"
                                  sx={{
                                    height: 18,
                                    "& .MuiChip-label": {
                                      fontSize: "11px",
                                      px: 0.8,
                                    },
                                  }}
                                />
                                <Chip
                                  label={`Proxy : ${String(item?.isProxy)}`}
                                  size="small"
                                  color="primary"
                                  sx={{
                                    height: 18,
                                    "& .MuiChip-label": {
                                      fontSize: "11px",
                                      px: 0.8,
                                    },
                                  }}
                                />
                                {
                                  item.isEligible === null ? null : (
                                    <Chip
                                      label={`Survey Visible : ${item.isEligible ? "Yes" : "No"}`}
                                      size="small"
                                      color="primary"
                                      sx={{
                                        height: 18,
                                    "& .MuiChip-label": {
                                      fontSize: "11px",
                                      px: 0.8,
                                    },
                                  }}
                                />)
                                }
                                
                              </Typography>

                               <Chip
                                  label={`IP : ${item.ipAddress ?? 'N/A'}`}
                                  size="small"
                                  color="secondary"
                                  sx={{
                                    height: 18,
                                    "& .MuiChip-label": {
                                      fontSize: "11px",
                                      px: 0.8,
                                    },
                                  }}
                                />
                            </Stack>
                          </Box>
                        </ListItem>
                      </Box>
                    ))
                  ) : (
                    <Stack alignItems="center" gap={0.8} flexWrap="wrap">
                      <Typography fontSize={18} fontWeight={500} padding={4}>
                        📝 {varisoulMessage}
                      </Typography>
                    </Stack>
                  )}
                </>
              )}
            </DialogContent>

            {historyTab === 0 && loginHistoryData.length > 0 && (
              <TablePagination
                component="div"
                count={loginHistoryData.length}
                page={loginPage}
                onPageChange={handleLoginPageChange}
                rowsPerPage={loginRowsPerPage}
                onRowsPerPageChange={handleLoginRowsPerPageChange}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Rows"
                sx={{
                  flexShrink: 0, // yahi asli fix hai, ab ye kabhi chhota nahi hoga
                  borderTop: 1,
                  borderColor: "divider",
                  overflow: "hidden",
                  p: 0,
                  ".MuiTablePagination-toolbar": {
                    minHeight: 48,
                    height: 48,
                    pl: 2,
                    pr: 1.5,
                    justifyContent: "flex-start",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                    {
                      fontSize: 14,
                      m: 0,
                    },
                  ".MuiTablePagination-select": {
                    fontSize: 14,
                    minWidth: 32,
                  },
                  ".MuiTablePagination-input": {
                    mr: 1.5,
                    ml: 0.5,
                  },
                  ".MuiTablePagination-displayedRows": {
                    mr: 1,
                  },
                  ".MuiTablePagination-actions": {
                    ml: 0.5,
                  },
                }}
              />
            )}

            {/* Footer */}
            <DialogActions>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setOpenLoginHistory(false)}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
      </Stack>
    </>
  );
};

export default PanelistForm;
